/**
 * 企业到期蒙层组件
 *
 * 使用方式：
 * import CorpExpireMask from 'src/page/admin-qidian/components/corp-expire-mask';
 * <CorpExpireMask />
 */

import CorpExpireMask from './index.vue';

export { CorpExpireMask };

export default CorpExpireMask;
